<template>
    <ResetPassword />
</template>
<script>
import ResetPassword from "@/components/ResetPassword/index.vue";

export default {
  components: {
    ResetPassword
  },
  metaInfo() {
    return {
      title: this.$t('user.change_password_label')
    }
  }
}
</script>